import { ref } from 'vue';

/**
 * The Set stores the imported tokens for which the warning dialog has already been shown.
 */
const confirmed = ref(new Set());

export function useUnverifiedCoins() {
  function checkAndConfirm(type: string) {
    const coin = type?.replace(/^0x0+/, '0x');
    if (confirmed.value.has(coin)) {
      return true;
    }
    confirmed.value.add(coin);
    return false;
  }

  return {
    checkAndConfirm,
  };
}
